import MarketingStandardTemplate from './Marketing-standard-template';
import MarketingCarouselTemplate from './Marketing-carousel-template';
import MarketingProductTemplate from './Marketing-product-template';
import SelectCards from '../components/Select-cards';
import UtilityCallPermissionTemplate from '../Utility-templates/Utility-call-permission-template';

const messageTypeOptions = [
  { label: 'Standard', value: 'STANDARD', description: 'Text message with optional buttons' },
  { label: 'Carousel', value: 'CAROUSEL', description: 'Swipable Cards' },
  { label: 'Products', value: 'PRODUCT', description: 'Catalog Products' },
  {
    label: 'Call Permission',
    value: 'CALL_PERMISSION',
    description: 'Ask the user for permission to receive a phone call',
  },
];

const MarketingTemplates = ({ control, watch, ...props }) => {
  const watchMessageType = watch('messageType');

  return (
    <>
      {/* Message Type Selection */}

      <div className="w-full mt-3">
        <label className="form-label">Message Type</label>

        <SelectCards
          control={control}
          name="messageType"
          options={messageTypeOptions}
          defaultValue="STANDARD"
        />
      </div>

      {/* Template Renderer */}

      {watchMessageType === 'STANDARD' && (
        <MarketingStandardTemplate control={control} watch={watch} {...props} />
      )}

      {watchMessageType === 'CAROUSEL' && (
        <MarketingCarouselTemplate control={control} watch={watch} {...props} />
      )}

      {watchMessageType === 'PRODUCT' && (
        <MarketingProductTemplate control={control} watch={watch} {...props} />
      )}
      {watchMessageType === 'CALL_PERMISSION' && (
        <UtilityCallPermissionTemplate control={control} watch={watch} {...props} />
      )}
    </>
  );
};

export default MarketingTemplates;
